import PropTypes from "prop-types";
import React from "react";

import Framed from "../Framed";

import * as styles from "./styles.module.scss";

const Notice = ({ children, frameStyle, title }) => (
  <div className={styles.container}>
    <Framed style={frameStyle}>
      <div className={styles.contentContainer}>
        <h2 className={styles.h2}>{title}</h2>
        {children}
      </div>
    </Framed>
  </div>
);

Notice.propTypes = {
  children: PropTypes.node.isRequired,
  frameStyle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Notice;
